<template>
  <div class="ui simple dropdown item borderless" id="indicator">
    <div class="ui basic label" :class="overall_color">
      {{ used_space }} / {{ total_space }}
      <div id="indicator-progress" class="ui progress" :class="overall_color">
        <div class="bar"></div>
      </div>
    </div>
    <div class="left big menu">
      <div class="item">
        当前套餐： <strong>{{ plan_name }}</strong>
      </div>
      <div class="divider"></div>
      <div class="item">
        <span class="ui text" :class="space_color">
          已用空间： {{ used_space }} ({{ used_space_percent }}%)
        </span>
      </div>
      <div class="item">
        总空间： {{ total_space }}
      </div>
      <div class="divider"></div>
      <div class="item">
        <span class="ui text" :class="download_color">
          已下载： {{ used_download }} ({{ used_download_percent }}%)
        </span>
      </div>
      <div class="item">
        下载上限： {{ total_download }}
      </div>
      <div class="divider"></div>
      <div class="item">
        <span class="ui text" :class="upload_color">
          已上传： {{ used_upload }}
        </span>
        <span v-if="total_upload > 0">
          ({{ used_upload_percent }}%)
        </span>
      </div>
      <div class="item">
        上传上限： {{ total_upload }}
      </div>
      <div class="divider"></div>
      <div class="item">
        <button class="ui small primary fluid button" @click="$router.push({name:'buy'})">购买套餐</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Indicator',
  props: [],
  components: {
  },
  data: function () {
    return {
    };
  },
  computed: {
    overall_color() {
      return this.color(Math.max(this.used_space_percent,
            this.used_upload_percent,
            this.used_download_percent));
    },
    space_color() {
      return this.color(this.used_space_percent);
    },
    upload_color() {
      return this.color(this.used_upload_percent);
    },
    download_color() {
      return this.color(this.used_download_percent);
    },
    total_space() {
      var val = this.client.quota.total_space;
      return this.display_size(val);
    },
    plan_name() {
      return this.client.plan ? this.client.plan.display_name : "";
    },
    used_space() {
      return this.bytes_to_human(this.client.quota.used_space, true, 0);
    },
    used_space_percent() {
      var used = this.client.quota.used_space;
      var total = this.client.quota.total_space;
      var ret = Math.round(total ? used * 100 / total : 0);
      return ret;
    },
    total_download() {
      var val = this.client.quota.total_download;
      return this.display_size(val);
    },
    used_download() {
      return this.bytes_to_human(this.client.quota.used_download, true, 0);
    },
    used_download_percent() {
      var used = this.client.quota.used_download;
      var total = this.client.quota.total_download;
      return Math.round(total > 0 ? used * 100 / total : 0);
    },
    total_upload() {
      var val = this.client.quota.total_upload;
      return this.display_size(val);
    },
    used_upload() {
      return this.bytes_to_human(this.client.quota.used_upload, true, 0);
    },
    used_upload_percent() {
      var used = this.client.quota.used_upload;
      var total = this.client.quota.total_upload;
      return Math.round(total > 0 ? used * 100 / total : 0);
    },
  },
  methods: {
    color(p) {
      if (p >= 90) {
        return "red";
      } else if (p >= 70) {
        return "orange";
      } else {
        return "blue";
      }
    },
    display_size(val) {
      if (val == 0) {
        return "无可用";
      }
      return val >= 0 ? this.bytes_to_human(val) : "无限制";
    },
    async update_progress_start() {
      var pre = 0;
      for (;;) {
        var a = this.used_space_percent;
        if (a != pre) {
          this.$("#indicator-progress").progress('set percent', a);
        }
        pre = a;
        await this.sleep(1000);
      }
    },
  },
  mounted() {
    this.$("#indicator-progress").progress({
      autoSuccess: false,
      showActivity: false,
    });
    this.update_progress_start();
  },
}
</script>

<style scoped>
#indicator {
  padding: 3px 8px 3px 8px;
}

#indicator-progress {
  margin-bottom: 0px;
}

#indicator-progress .bar {
  height: 3px;
}

</style>

